import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard } from 'lucide-react';
export function Financing() {
  return <section className="py-12 bg-background border-y" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left" data-id="element-87">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-88">
            <CreditCard className="w-8 h-8 text-primary" data-id="element-89" />
          </div>
          <div data-id="element-90">
            <h3 className="font-heading text-2xl font-bold mb-2" data-id="element-91">
              Flexible Financing Available
            </h3>
            <p className="text-muted-foreground max-w-2xl" data-id="element-92">
              We believe everyone deserves access to quality care. We offer
              flexible, affordable financing options to ensure your treatment
              fits comfortably within your budget.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}